// extracted by mini-css-extract-plugin
module.exports = {"CommentReplyButton":"CommentReplyButton_CommentReplyButton__3NPiy","ReplyButton":"CommentReplyButton_ReplyButton__weEFW"};